import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

@Component({
  selector: 'lohi-pie-chart',
  templateUrl: './pie-chart.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PieChartComponent implements OnInit {
  @Input() public earnings: number;
  @Input() public lostEarnings: number;
  @Input() public daysOfHistory = 30;
  @Input() public sleepers = false;

  /*public get target(): number {
    return this.driverTarget;
  }*/

  public chart: Chart;

  constructor() {}

  public ngOnInit() {
    const title = this.sleepers
      ? `<div class="text-lg font-bold">Sleepers <span class="text-blue-500">${this.daysOfHistory || 30}d</span></div>`
      : `<div class="text-lg font-bold">Day Cabs <span class="text-blue-500">${this.daysOfHistory || 30}d</span></div>`;
    this.chart = new Chart({
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      tooltip: {
        formatter() {
          return (
            `<span class="font-bold" style="color: ${this.point.color}">` +
            this.point.name +
            '</span> ' +
            currencyFormatter.format(this.y)
          );
        },
      },
      title: {
        align: 'left',
        useHTML: true,
        text: title,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            formatter: formatCurrency,
          },
        },
      },
      series: [],
    });

    this.chart.addSeries(
      {
        name: 'Earnings',
        type: 'pie',
        data: [
          {
            name: 'Earnings',
            y: this.earnings / 100,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#070707'],
                [1, '#3e3e52'],
              ],
            },
          },
          {
            name: 'Lost Earnings',
            y: this.lostEarnings / 100,
            color: '#EF6048',
          },
        ],
      },
      true,
      true,
    );
  }
}
function formatCurrency() {
  if (this.y === 0) {
    return '';
  }
  return `<div style="color: ${this.point.color}">${this.point.name}<br> <span style="color: ${
    this.point.color
  }" class="font-bold">${currencyFormatter.format(this.y)}</span></div>`;
}
